const dtHandler = require('../../../../../components/dt/dt-handler')

export function fill(detail, htmlFc) {
    clean(htmlFc)
    const rowAverage = htmlFc.fullcontHTML.querySelectorAll('.row-extrainfo');

    rowAverage.forEach(row => {
        if (row.classList.contains('dn')) {
            row.classList.remove('dn')
        }
    })
    // fillAverageTable(detail[0].behavior, htmlFc)
    fillPayableTable(detail[1].amount, htmlFc)
    fillBestTenTable(detail[2].performance, htmlFc)
    fillLowestTable(detail[2].performance, htmlFc)
    fillReportTable(detail[3].unpaid, htmlFc)
}

function fillAverageTable(datos, htmlFc) {

    const columns = [
        { key: 'roi', label: 'ROI', format: 'percent', behavior: true, displayText: true, title: 'roi_title' },
        { key: 'profit', label: 'Revenue', format: 'star', behavior: true, displayText: true, title: 'profit_title' },
    ];

    const html = dtHandler.dtSimpleFc(datos, columns);

    const cont = htmlFc.fullcontHTML.querySelector('#provider-fullcont-behaivor');
    cont.innerHTML = ""
    cont.innerHTML = html

    return
}

function fillPayableTable(datos, htmlFc) {

    const columns = [
        { key: 'current', label: 'Current', format: 'cash', behavior: false, displayText: true },
        { key: 'total_due_30_days', label: '0-30d', format: 'cash', behavior: false, displayText: true },
        { key: 'total_due_31_to_60_days', label: '31-60d', format: 'cash', behavior: false, displayText: true },
        { key: 'total_due_61_to_90_days', label: '61-90d', format: 'cash', behavior: false, displayText: true },
        { key: 'total_due_over_90_days', label: '90+d', format: 'cash', behavior: false, displayText: true },
        { key: 'total_due', label: 'Total', format: 'cash', behavior: false, displayText: true },
    ];

    const html = dtHandler.dtSimpleFc(datos, columns);

    const cont = htmlFc.fullcontHTML.querySelector('#provider-fullcont-report');
    cont.innerHTML = ""
    cont.innerHTML = html

    return
}

function fillBestTenTable(datos, htmlFc) {

    const columns = [
        { key: 'item_name', label: 'Item Name', format: '', behavior: false, displayText: true },
        { key: 'roi', label: 'ROI', format: 'percent', behavior: false, displayText: true },
        // star
        { key: 'roi', label: 'ROI Star', format: 'bar', behavior: true, displayText: false, title: false },

        { key: 'profit', label: 'Profit', format: 'cash', behavior: false, displayText: true },
        // star
        { key: 'profit', label: 'Profit Star', format: 'bar', behavior: true, displayText: false, title: false },
    ];

    const html = dtHandler.dtSimpleFc(datos[0].best, columns);

    const cont = htmlFc.fullcontHTML.querySelector('#multitable-best-provider-fullcont');
    cont.innerHTML = ""
    cont.innerHTML = html
    return
}

function fillLowestTable(datos, htmlFc) {

    const columns = [
        { key: 'item_name', label: 'Item Name', format: '', behavior: false, displayText: true },
        { key: 'roi', label: 'ROI', format: 'percent', behavior: false, displayText: true },
        // star
        { key: 'roi', label: 'ROI Star', format: 'bar', behavior: true, displayText: false, title: false },

        { key: 'profit', label: 'Profit', format: 'cash', behavior: false, displayText: true },
        // star
        { key: 'profit', label: 'Profit Star', format: 'bar', behavior: true, displayText: false, title: false },
    ];

    const html = dtHandler.dtSimpleFc(datos[0].worst, columns);

    const cont = htmlFc.fullcontHTML.querySelector('#multitable-worst-provider-fullcont');
    cont.innerHTML = ""
    cont.innerHTML = html
    return
}

function fillReportTable(datos, htmlFc) {
    const columns = [
        { key: 'date', label: 'Date', format: '', behavior: false, displayText: true, outsideHead: true },
        { key: 'code', label: 'Code', format: '', behavior: false, displayText: true, outsideHead: true },
        { key: 'due_date', label: 'Due Date', format: '', behavior: false, displayText: true, outsideHead: true },
        { key: 'original_amount', label: 'Original Amount', format: 'cash', behavior: false, displayText: true, outsideHead: true },
        { key: 'due_amount', label: 'Due Amount', format: 'cash', behavior: false, displayText: true, outsideHead: true },
    ];

    const html = dtHandler.dtSimpleFc(datos, columns, 'overdue_age');

    const title = htmlFc.fullcontHTML.querySelector('#provider-name-fullcont-report');
    title.innerHTML = ""
    title.innerHTML = datos[0].provider_name

    const cont = htmlFc.fullcontHTML.querySelector('#multitable-report-provider-fullcont');
    cont.innerHTML = ""
    cont.innerHTML = html
    return
}

export function clean(htmlFc) {
    const rowAverage = htmlFc.fullcontHTML.querySelectorAll('.row-extrainfo');
    rowAverage.forEach(row => {
        if (!row.classList.contains('dn')) {
            row.classList.add('dn')
        }
    })
    return
}

export function printBehaivor(detail, htmlFc) {
    const contain = htmlFc.fullcontHTML.querySelector('.performancePage');
    const rows = contain.querySelectorAll('.row-extrainfo');

    let htmlToPrint = '';
    rows.forEach(row => {
        const title = row.querySelector('.font-card-title')?.outerHTML || '';
        const tableContent = row.querySelector('.multitable-report')?.outerHTML || '';

        if (tableContent) {
            htmlToPrint += `
                <div class="print-section">
                    <div class="print-title-wrapper">${title}</div>
                    <div class="print-table-container">
                        ${tableContent}
                    </div>
                </div>`;
        }
    });

    if (htmlToPrint) {
        printHtmlInIframe(htmlToPrint);
    }
}

function printHtmlInIframe(html) {
    let iframe = document.getElementById('print-iframe');
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'print-iframe';
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);
    }

    const doc = iframe.contentWindow.document;
    const styles = document.querySelectorAll('link[rel="stylesheet"], style');
    let styleTags = '';
    styles.forEach(tag => { styleTags += tag.outerHTML; });

    doc.open();
    doc.write(`
        <!DOCTYPE html>
        <html>
            <head>
                <title>Reporte beeStock</title>
                ${styleTags} 
                <style>
                    @media print {
                        // @page { margin: 1cm; }
                        body { 
                            background: white !important; 
                            width: 100% !important; 
                            margin: 0 !important; 
                            padding: 0 !important;
                        }
                        
                        /* Contenedor principal de cada tabla */
                        .print-section {
                            width: 100% !important;
                            display: flex !important;
                            flex-direction: column !important;
                            align-items: center !important;
                        }

                        .print-title-wrapper {
                            width: 99%;
                        }

                        .print-table-container {
                            width: 100% !important;
                            display: flex !important;
                            justify-content: center !important;
                        }

                        table, .multitable-report {
                            margin-left: auto !important;
                            margin-right: auto !important;
                            float: none !important;
                            width: 99% !important;
                        }

                        .card {
                            border: none !important;
                            box-shadow: none !important;
                            background: transparent !important;
                            margin: 0 !important;
                            padding: 0 !important;
                            width: 100% !important;
                        }

                        * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                    }
                </style>
            </head>
            <body>
                ${html}
            </body>
        </html>
    `);
    doc.close();

    setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    }, 600);
}